const COLORS = {
  darkBg: '#0A1A0F',
  surface: '#1A2E1F',
  primaryText: '#F0F9F2',
  winning: '#00E676',
  losing: '#FF5252',
  gold: '#FFD740',
  interactive: '#69F0AE',
  brandEmerald: '#064E3B',
  divider: '#2D4A33',
};

const TEAM1_BG = 'rgba(0, 230, 118, 0.08)';
const TEAM2_BG = 'rgba(6, 78, 59, 0.35)';
const WIN_BG = 'rgba(0, 230, 118, 0.12)';
const LOSE_BG = 'rgba(255, 82, 82, 0.12)';
const PRESS_BG = 'rgba(105, 240, 174, 0.08)';

const PALETTE_LABELS: Array<{ key: keyof typeof COLORS; label: string }> = [
  { key: 'darkBg', label: 'Dark Background' },
  { key: 'surface', label: 'Surface/Card' },
  { key: 'primaryText', label: 'Primary Text' },
  { key: 'winning', label: 'Winning/Positive' },
  { key: 'losing', label: 'Losing/Negative' },
  { key: 'gold', label: 'Gold Accent' },
  { key: 'interactive', label: 'Interactive Buttons' },
  { key: 'brandEmerald', label: 'Brand Emerald' },
  { key: 'divider', label: 'Divider/Border' },
];

const mockPars = [4, 3, 5, 4, 4, 3, 5, 4, 4];
const mockHoles = [1, 2, 3, 4, 5, 6, 7, 8, 9];

const mockPlayers = {
  team1: [
    { name: 'Murph', scores: [4, 3, 6, 4, 5, 3, 4, 4, 3] },
    { name: 'Sully', scores: [5, 3, 5, 5, 4, 4, 5, 3, 4] },
  ],
  team2: [
    { name: 'Fitz', scores: [4, 4, 5, 3, 4, 3, 6, 4, 5] },
    { name: 'Dono', scores: [5, 2, 5, 4, 5, 3, 5, 5, 4] },
  ],
};

function ScorecardGridSection() {
  const activeHole = 5;

  const cellStyle = (score: number, par: number, holeNum: number): React.CSSProperties => {
    const isActive = holeNum === activeHole;
    let bg = COLORS.surface;
    if (score < par) bg = WIN_BG;
    else if (score > par) bg = LOSE_BG;
    if (isActive) bg = 'rgba(255, 215, 64, 0.2)';
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 900,
      fontSize: '20px',
      fontFamily: 'monospace',
      color: score < par ? COLORS.winning : score > par ? COLORS.losing : COLORS.primaryText,
      background: bg,
      borderRight: `1px solid ${COLORS.divider}`,
      borderBottom: `1px solid ${COLORS.divider}`,
      height: '36px',
    };
  };

  return (
    <div data-testid="section-scorecard-grid">
      <h2 style={{ color: COLORS.gold, fontWeight: 800, fontSize: '16px', marginBottom: '8px' }}>
        1. Scorecard Grid
      </h2>
      <div style={{ background: COLORS.surface, borderRadius: '10px', overflow: 'hidden', border: `1px solid ${COLORS.divider}` }}>
        <div style={{ display: 'grid', gridTemplateColumns: '60px repeat(9, 1fr) 44px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, background: COLORS.brandEmerald, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '28px' }}>
            HOLE
          </div>
          {mockHoles.map((h) => (
            <div key={h} data-testid={`grid-hole-${h}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '15px', color: COLORS.gold, background: h === activeHole ? 'rgba(255,215,64,0.2)' : COLORS.brandEmerald, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '28px' }}>
              {h}
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '15px', color: COLORS.primaryText, background: COLORS.brandEmerald, borderBottom: `1px solid ${COLORS.divider}`, height: '28px' }}>
            OUT
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, background: COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '24px', opacity: 0.7 }}>
            Par
          </div>
          {mockPars.map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', fontFamily: 'monospace', color: COLORS.primaryText, background: COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '24px', opacity: 0.7 }}>
              {p}
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', fontFamily: 'monospace', color: COLORS.primaryText, background: COLORS.darkBg, borderBottom: `1px solid ${COLORS.divider}`, height: '24px', opacity: 0.7 }}>
            {mockPars.reduce((a, b) => a + b, 0)}
          </div>

          {[...mockPlayers.team1, ...mockPlayers.team2].map((player, pIdx) => {
            const isTeam1 = pIdx < 2;
            const teamBg = isTeam1 ? TEAM1_BG : TEAM2_BG;
            return (
              <div key={player.name} style={{ display: 'contents' }}>
                <div data-testid={`grid-player-${player.name}`} style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', fontWeight: 800, fontSize: '16px', color: COLORS.primaryText, background: teamBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '36px' }}>
                  {player.name}
                </div>
                {player.scores.map((s, i) => (
                  <div key={i} data-testid={`grid-score-${player.name}-${mockHoles[i]}`} style={cellStyle(s, mockPars[i], mockHoles[i])}>
                    {s}
                  </div>
                ))}
                <div data-testid={`grid-total-${player.name}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '18px', fontFamily: 'monospace', color: COLORS.primaryText, background: teamBg, borderBottom: `1px solid ${COLORS.divider}`, height: '36px' }}>
                  {player.scores.reduce((a, b) => a + b, 0)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function HoleDetailSection() {
  const players = [
    { name: 'Murph', score: 4, par: 4 },
    { name: 'Sully', score: 5, par: 4 },
    { name: 'Fitz', score: 3, par: 4 },
    { name: 'Dono', score: 4, par: 4 },
  ];

  const scoreLabel = (score: number, par: number) => {
    const diff = score - par;
    if (diff <= -2) return 'Eagle';
    if (diff === -1) return 'Birdie';
    if (diff === 0) return 'Par';
    if (diff === 1) return 'Bogey';
    if (diff === 2) return 'Dbl Bogey';
    return `+${diff}`;
  };

  return (
    <div data-testid="section-hole-detail">
      <h2 style={{ color: COLORS.gold, fontWeight: 800, fontSize: '16px', marginBottom: '8px' }}>
        2. Hole Detail Carousel
      </h2>
      <div style={{ background: COLORS.surface, borderRadius: '10px', border: `1px solid ${COLORS.divider}`, overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '10px 12px', borderBottom: `1px solid ${COLORS.divider}`, background: COLORS.brandEmerald }}>
          <span style={{ color: COLORS.primaryText, fontSize: '22px', opacity: 0.4 }}>‹</span>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 900, fontSize: '18px', color: COLORS.primaryText }} data-testid="detail-hole-title">Hole 5</div>
            <div style={{ fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, opacity: 0.7 }} data-testid="detail-hole-info">Par 4 · 380 yds · SI 7 · Front 9</div>
          </div>
          <span style={{ color: COLORS.primaryText, fontSize: '22px' }}>›</span>
        </div>

        <div style={{ padding: '12px' }}>
          {players.map((p, idx) => {
            const isTeam1 = idx < 2;
            const bg = isTeam1 ? TEAM1_BG : TEAM2_BG;
            const scoreColor = p.score < p.par ? COLORS.winning : p.score > p.par ? COLORS.losing : COLORS.primaryText;
            return (
              <div key={p.name} data-testid={`detail-player-row-${p.name}`} style={{ background: bg, borderRadius: '8px', padding: '10px 12px', marginBottom: '8px', border: `1px solid ${COLORS.divider}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <span data-testid={`detail-player-name-${p.name}`} style={{ fontWeight: 800, fontSize: '16px', color: COLORS.primaryText }}>{p.name}</span>
                  <span data-testid={`detail-score-label-${p.name}`} style={{ fontWeight: 700, fontSize: '15px', color: scoreColor }}>{scoreLabel(p.score, p.par)}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px' }}>
                  <button style={{ width: '48px', height: '48px', borderRadius: '50%', border: `2px solid ${COLORS.divider}`, background: COLORS.darkBg, color: COLORS.interactive, fontSize: '24px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} data-testid={`preview-btn-minus-${p.name}`}>
                    −
                  </button>
                  <div data-testid={`detail-score-display-${p.name}`} style={{ width: '56px', height: '56px', borderRadius: '12px', border: `2px solid ${COLORS.divider}`, background: COLORS.darkBg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '20px', fontFamily: 'monospace', color: scoreColor }}>
                    {p.score}
                  </div>
                  <button style={{ width: '48px', height: '48px', borderRadius: '50%', border: `2px solid ${COLORS.divider}`, background: COLORS.darkBg, color: COLORS.interactive, fontSize: '24px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} data-testid={`preview-btn-plus-${p.name}`}>
                    +
                  </button>
                </div>
              </div>
            );
          })}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '8px 0 0', borderTop: `1px solid ${COLORS.divider}`, marginTop: '4px' }}>
            <span style={{ fontWeight: 900, fontSize: '18px', color: COLORS.primaryText }}>Front</span>
            <span data-testid="detail-dollar-status" style={{ fontWeight: 900, fontSize: '18px', fontFamily: 'monospace', color: COLORS.winning }}>+$10</span>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '8px', padding: '0 12px 12px' }}>
          <button style={{ flex: 1, padding: '12px', borderRadius: '10px', background: COLORS.interactive, color: COLORS.darkBg, fontWeight: 900, fontSize: '16px', border: 'none', cursor: 'pointer' }} data-testid="preview-save-next">
            Save & Next →
          </button>
          <button style={{ padding: '12px 20px', borderRadius: '10px', background: COLORS.gold, color: COLORS.darkBg, fontWeight: 900, fontSize: '16px', border: 'none', cursor: 'pointer' }} data-testid="preview-press-btn">
            ⚡ Press
          </button>
        </div>
      </div>
    </div>
  );
}

function BetStatusSection() {
  const closedBets = [
    { label: 'Front', winner: 'Murph/Sully', bets: 2, dollars: 20 },
  ];
  const openBets = [
    { leg: 'Back', groups: [{ standing: '+1', count: 2, color: COLORS.winning }, { standing: 'E', count: 1, color: COLORS.primaryText }] },
    { leg: 'Overall', groups: [{ standing: '-1', count: 1, color: COLORS.losing }] },
  ];

  return (
    <div data-testid="section-bet-status">
      <h2 style={{ color: COLORS.gold, fontWeight: 800, fontSize: '16px', marginBottom: '8px' }}>
        3. Bet Status Modal
      </h2>
      <div style={{ background: COLORS.surface, borderRadius: '10px', border: `1px solid ${COLORS.divider}`, overflow: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 14px', borderBottom: `1px solid ${COLORS.divider}`, background: COLORS.brandEmerald }}>
          <span data-testid="bet-status-title" style={{ fontWeight: 900, fontSize: '16px', color: COLORS.primaryText }}>Bet Status — Hole 14 of 18</span>
          <span style={{ color: COLORS.primaryText, opacity: 0.6, fontSize: '20px', cursor: 'pointer' }}>✕</span>
        </div>

        <div style={{ padding: '14px' }}>
          <h3 style={{ fontWeight: 900, fontSize: '15px', color: COLORS.gold, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '8px' }}>
            Closed Bets
          </h3>
          {closedBets.map((cb) => (
            <div key={cb.label} data-testid={`bet-closed-${cb.label}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: COLORS.darkBg, borderRadius: '8px', marginBottom: '6px', border: `1px solid ${COLORS.divider}` }}>
              <span style={{ fontWeight: 900, fontSize: '16px', color: COLORS.primaryText }}>{cb.label}:</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span data-testid={`bet-closed-winner-${cb.label}`} style={{ fontWeight: 800, fontSize: '16px', color: COLORS.primaryText, opacity: 0.7 }}>{cb.winner}</span>
                <span data-testid={`bet-closed-amount-${cb.label}`} style={{ fontWeight: 900, fontSize: '18px', fontFamily: 'monospace', color: COLORS.winning }}>+{cb.bets}</span>
                <span style={{ fontWeight: 900, fontSize: '18px', color: COLORS.winning }}>({`+$${cb.dollars}`})</span>
              </div>
            </div>
          ))}

          <div style={{ height: '1px', background: COLORS.divider, margin: '14px 0' }} />

          <h3 style={{ fontWeight: 900, fontSize: '15px', color: COLORS.gold, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '8px' }}>
            Open Bets (3 active)
          </h3>
          {openBets.map((leg) => (
            <div key={leg.leg} style={{ marginBottom: '10px' }}>
              <p data-testid={`bet-open-leg-${leg.leg}`} style={{ fontWeight: 900, fontSize: '16px', color: COLORS.primaryText, marginBottom: '4px' }}>
                {leg.leg} ({leg.groups.reduce((s, g) => s + g.count, 0)} bets)
              </p>
              {leg.groups.map((g) => (
                <div key={g.standing} data-testid={`bet-open-standing-${g.standing}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: g.color === COLORS.winning ? WIN_BG : g.color === COLORS.losing ? LOSE_BG : COLORS.darkBg, borderRadius: '6px', marginBottom: '4px', border: `1px solid ${COLORS.divider}` }}>
                  <span style={{ fontWeight: 900, fontSize: '18px', fontFamily: 'monospace', color: g.color }}>{g.standing}</span>
                  <span style={{ fontWeight: 900, fontSize: '18px', color: g.color }}>x{g.count}</span>
                </div>
              ))}
            </div>
          ))}

          <div style={{ height: '2px', background: COLORS.divider, margin: '12px 0' }} />

          <div data-testid="bet-net-summary" style={{ background: LOSE_BG, borderRadius: '8px', padding: '12px', textAlign: 'center', border: `1px solid ${COLORS.divider}` }}>
            <p style={{ fontWeight: 900, fontSize: '18px', color: COLORS.losing }}>
              Fitz/Dono currently down 1 bet
              <span style={{ marginLeft: '6px', fontWeight: 900, fontSize: '18px' }}>(-$10)</span>
            </p>
          </div>

          <div style={{ height: '1px', background: COLORS.divider, margin: '14px 0' }} />

          <h3 style={{ fontWeight: 700, fontSize: '15px', color: COLORS.gold, opacity: 0.6, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>
            Projected Total
          </h3>
          <div style={{ background: COLORS.darkBg, borderRadius: '8px', padding: '10px 14px', border: `1px solid ${COLORS.divider}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
              <span data-testid="projected-team-a-name" style={{ fontWeight: 800, fontSize: '16px', color: COLORS.primaryText }}>Murph/Sully</span>
              <span data-testid="projected-team-a-amount" style={{ fontWeight: 900, fontSize: '18px', fontFamily: 'monospace', color: COLORS.winning }}>+$30 <span style={{ fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, opacity: 0.5 }}>(+3 bets)</span></span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span data-testid="projected-team-b-name" style={{ fontWeight: 800, fontSize: '16px', color: COLORS.primaryText }}>Fitz/Dono</span>
              <span data-testid="projected-team-b-amount" style={{ fontWeight: 900, fontSize: '18px', fontFamily: 'monospace', color: COLORS.losing }}>-$30 <span style={{ fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, opacity: 0.5 }}>(-3 bets)</span></span>
            </div>
          </div>
          <p data-testid="projected-footnote" style={{ fontSize: '15px', color: COLORS.primaryText, opacity: 0.4, marginTop: '6px', fontStyle: 'italic', textAlign: 'center' }}>
            Projected if all open bets close at current standing
          </p>
        </div>
      </div>
    </div>
  );
}

function PressRowsSection() {
  const pressHoles = [10, 11, 12, 13, 14, 15, 16, 17, 18];
  const frontStatuses = [1, 1, 0, 1, 2, 2, 1, 0, -1];
  const pressStatuses = [null, null, null, 0, 0, -1, -1, -1, -2];

  return (
    <div data-testid="section-press-rows">
      <h2 style={{ color: COLORS.gold, fontWeight: 800, fontSize: '16px', marginBottom: '8px' }}>
        4. Press Rows
      </h2>
      <div style={{ background: COLORS.surface, borderRadius: '10px', overflow: 'hidden', border: `1px solid ${COLORS.divider}` }}>
        <div style={{ display: 'grid', gridTemplateColumns: '64px repeat(9, 1fr) 44px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, background: COLORS.brandEmerald, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '28px' }}>
            HOLE
          </div>
          {pressHoles.map((h) => (
            <div key={h} data-testid={`press-hole-${h}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '15px', color: COLORS.gold, background: COLORS.brandEmerald, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '28px' }}>
              {h}
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '15px', color: COLORS.primaryText, background: COLORS.brandEmerald, borderBottom: `1px solid ${COLORS.divider}`, height: '28px' }}>
            TOT
          </div>

          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', fontWeight: 800, fontSize: '15px', color: COLORS.primaryText, background: COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
            BACK
          </div>
          {frontStatuses.map((s, i) => (
            <div key={i} data-testid={`press-back-cell-${pressHoles[i]}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '15px', fontFamily: 'monospace', color: s > 0 ? COLORS.winning : s < 0 ? COLORS.losing : COLORS.primaryText, background: s > 0 ? WIN_BG : s < 0 ? LOSE_BG : COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
              {s === 0 ? 'E' : s > 0 ? `+${s}` : `${s}`}
            </div>
          ))}
          <div data-testid="press-back-total" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '15px', fontFamily: 'monospace', color: COLORS.losing, background: LOSE_BG, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
            -1
          </div>

          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', fontWeight: 800, fontSize: '15px', color: COLORS.interactive, background: PRESS_BG, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
            B Press
          </div>
          {pressStatuses.map((s, i) => (
            <div key={i} data-testid={`press-press-cell-${pressHoles[i]}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '15px', fontFamily: 'monospace', color: s === null ? `${COLORS.primaryText}33` : s > 0 ? COLORS.winning : s < 0 ? COLORS.losing : COLORS.primaryText, background: s === null ? COLORS.darkBg : s > 0 ? WIN_BG : s < 0 ? LOSE_BG : COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
              {s === null ? '-' : s === 0 ? 'P E' : s > 0 ? `P +${s}` : `P ${s}`}
            </div>
          ))}
          <div data-testid="press-press-total" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '15px', fontFamily: 'monospace', color: COLORS.losing, background: LOSE_BG, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
            P -2
          </div>

          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', fontWeight: 800, fontSize: '15px', color: COLORS.primaryText, background: COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
            OVERALL
          </div>
          {[1, 2, 2, 3, 3, 2, 1, 0, -1].map((s, i) => (
            <div key={i} data-testid={`press-overall-cell-${pressHoles[i]}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '15px', fontFamily: 'monospace', color: s > 0 ? COLORS.winning : s < 0 ? COLORS.losing : COLORS.primaryText, background: s > 0 ? WIN_BG : s < 0 ? LOSE_BG : COLORS.darkBg, borderRight: `1px solid ${COLORS.divider}`, borderBottom: `1px solid ${COLORS.divider}`, height: '32px' }}>
              {s === 0 ? 'E' : s > 0 ? `+${s}` : `${s}`}
            </div>
          ))}
          <div data-testid="press-overall-total" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: '15px', fontFamily: 'monospace', color: COLORS.losing, background: LOSE_BG, height: '32px' }}>
            -1
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ColorPreview() {
  return (
    <div style={{ background: COLORS.darkBg, minHeight: '100vh', padding: '16px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }} data-testid="color-preview-page">
      <h1 style={{ color: COLORS.primaryText, fontWeight: 900, fontSize: '22px', textAlign: 'center', marginBottom: '4px' }}>
        Dark Theme Color Preview
      </h1>
      <p style={{ color: COLORS.primaryText, opacity: 0.5, fontSize: '15px', textAlign: 'center', marginBottom: '16px' }}>
        Outdoor / sunlight readability test
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '20px', padding: '12px', background: COLORS.surface, borderRadius: '10px', border: `1px solid ${COLORS.divider}` }} data-testid="color-swatch-legend">
        {PALETTE_LABELS.map(({ key, label }) => (
          <div key={key} data-testid={`swatch-${key}`} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '4px', background: COLORS[key], border: `1px solid ${COLORS.divider}` }} />
            <div>
              <div style={{ fontWeight: 700, fontSize: '15px', color: COLORS.primaryText }}>{label}</div>
              <div style={{ fontWeight: 700, fontSize: '15px', color: COLORS.primaryText, opacity: 0.5, fontFamily: 'monospace' }}>{COLORS[key]}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', maxWidth: '480px', margin: '0 auto' }}>
        <ScorecardGridSection />
        <HoleDetailSection />
        <BetStatusSection />
        <PressRowsSection />
      </div>
    </div>
  );
}
